import Vue from 'vue'
import Router from 'vue-router'
import login from '@/components/login'
import main from '@/components/main'
import loginout from '@/components/loginout'
import signup from '@/components/signup'
import signup_wechatpay_erweima from '@/components/signup_wechatpay_erweima'
import signup_check from '@/components/signup_check'
import signup_pay from '@/components/signup_pay'
import signup_success from '@/components/signup_success'
import signup_code from '@/components/signup_code'
import signup_result from "@/components/signup_result";
import Authentication from "@/components/Authentication";
import Authentication_step2 from "@/components/Authentication_step2";
import Authentication_step2_showdata from "@/components/Authentication_step2_showdata";
import Authentication_wechatpay_erweima from "@/components/Authentication_wechatpay_erweima";
import Authentication_fapiao from "@/components/Authentication_fapiao";
import Authentication_show from "@/components/Authentication_show";
import Authentication_pay from "@/components/Authentication_pay";
import msg_show from "@/components/msg_show";
import password from "@/components/password";
import Authentication2 from "@/components/Authentication2";
import Authentication2_step1 from "@/components/Authentication2_step1";
import Authentication2_step2 from "@/components/Authentication2_step2";
import Authentication2_step3 from "@/components/Authentication2_step3";
import Authentication2_step3_erweima from "@/components/Authentication2_step3_erweima";
import Authentication2_step4 from "@/components/Authentication2_step4";


import axios from 'axios'
Vue.prototype.$axios = axios;

Vue.use(Router)

const router = new Router({
      routes: [
            {
                  path: '/',
                  name: 'login',
                  component: login
            },
            {
                  path: '/main',
                  name: 'main',
                  component: main
            },
            {
                  path: '/loginout',
                  name: 'loginout',
                  component: loginout
            },
            {
                  path: '/signup',
                  name: 'signup',
                  component: signup
            },
            {
                  path: '/signup_check',
                  name: 'signup_check',
                  component: signup_check
            },
            {
                  path: '/signup_pay',
                  name: 'signup_pay',
                  component: signup_pay
            },
            {
                  path: '/signup_wechatpay_erweima/:orderid',
                  name: 'signup_wechatpay_erweima',
                  component: signup_wechatpay_erweima
            },
            {
                  path: '/signup_success',
                  name: 'signup_success',
                  component: signup_success
            },
            {
                  path: '/signup_code',
                  name: 'signup_code',
                  component: signup_code
            },
            {
                  path: '/signup_result',
                  name: 'signup_result',
                  component: signup_result
            },
            {
                  path: '/Authentication',
                  name: 'Authentication',
                  component: Authentication
            },
            {
                  path: '/Authentication_step2',
                  name: 'Authentication_step2',
                  component: Authentication_step2
            },
            {
                  path: '/Authentication_step2_showdata',
                  name: 'Authentication_step2_showdata',
                  component: Authentication_step2_showdata
            },
            {
                  path: '/Authentication_wechatpay_erweima/:orderid',
                  name: 'Authentication_wechatpay_erweima',
                  component: Authentication_wechatpay_erweima
            },
            {
                  path: '/Authentication_fapiao',
                  name: 'Authentication_fapiao',
                  component: Authentication_fapiao
            },
            {
                  path: '/Authentication_show',
                  name: 'Authentication_show',
                  component: Authentication_show
            },
            {
                  path: '/Authentication_pay',
                  name: 'Authentication_pay',
                  component: Authentication_pay
            },
            {
                  path: '/msg_show/:id',
                  name: 'msg_show',
                  component: msg_show
            },
            {
                  path: '/password',
                  name: 'password',
                  component: password
            },
            {
                  path: '/Authentication2',
                  name: 'Authentication2',
                  component: Authentication2
            },
            {
                  path: '/Authentication2_step1',
                  name: 'Authentication2_step1',
                  component: Authentication2_step1
            },
            {
                  path: '/Authentication2_step2',
                  name: 'Authentication2_step2',
                  component: Authentication2_step2
            },
            {
                  path: '/Authentication2_step3',
                  name: 'Authentication2_step3',
                  component: Authentication2_step3
            },
            {
                  path: '/Authentication2_step3_erweima',
                  name: 'Authentication2_step3_erweima',
                  component: Authentication2_step3_erweima
            },
            {
                  path: '/Authentication2_step4',
                  name: 'Authentication2_step4',
                  component: Authentication2_step4
            },
      ]
})


//路由守卫
router.beforeEach((to, from, next) => {
      let membertoken = localStorage.getItem('membertoken');
      //console.log(to.name);
      if (to.name != 'login' && to.name!='loginout') {
            if (!membertoken) {

                  alert('token为空，请重新登录！');
                  window.location.href = '/member2/';
            } else {
                  axios({
                        method: 'get',
                        url: '/api/member2/',
                        data: '',
                        headers: {
                              membertoken: membertoken
                        }
                  }).then(function OnSuccess(response) {

                        if (response.data == 'Error') {
                              localStorage.removeItem("membertoken");
                              //alert('登录超时，请重新登录！');
                              console.log('登录超时，请重新登录！');
                              window.location.href = '/member2/';
                        }else{
                              if(response.data.middle_other==null && to.name != 'main' ){
                                    swal(
                                          {
                                                title: '请至“我的主页/个人资料”补充完善您的个人资料',
                                                text: '',
                                                type: 'error',
                                                confirmButtonColor: '#4fa7f3',
                                          }
                                    )
                                    window.location.href="/member2/#/main";
                                    //alert('请先填写基本资料!');
                                    //window.location.href = '/member2/#/main';
                              }
                              //强制刷新，重新传宣页面

                              console.log(from.name+'=>'+to.name);
                              console.log('dump 5');
                              if(to.name!=from.name && to.name!=null && from.name!=null ){
                                    //history.go(0);
                                    //if(from.name!="login" && to.name!="main"){
                                          window.location.reload();
                                    //}
                              }






                        }

                  }.bind(this)).catch(function OnError(response) {


                        return response;
                  });



            }





      }

      next();
});

export default router;


// WEBPACK FOOTER //
// ./src/router/index.js